export default "__VITE_ASSET__3f6af1ba__"